import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IService } from "../domain/IService";
import { DailyTableService } from "../services/dt.service";
import { RootState } from "reducers";
import { IDateRangeRequestParams } from "Dashboard/domain/IDateRangeRequestParams";

interface dtServiceState {
  loading: boolean;
  services: IService[];
  error: any;
}

const initialState: dtServiceState = {
  loading: false,
  services: [],
  error: undefined,
};

export const getBasicDataForServicesOfResources = createAsyncThunk(
  "DailyTable/getBasicDataForServicesOfResources",
  async (data?: IDateRangeRequestParams) => {
    try {
      const result = await DailyTableService.getBasicDataForServicesOfResources(
        data
      );
      return result.services;
    } catch (err) {
      setError(err);
    }
  }
);

export const dtServiceSlice = createSlice({
  name: "Services",
  initialState: initialState,
  reducers: {
    setServices: (state, action: PayloadAction<IService[]>) => {
      state.services = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getBasicDataForServicesOfResources.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getBasicDataForServicesOfResources.fulfilled,
      (state, action) => {
        state.services = action.payload ? action.payload : [];
        state.loading = false;
      }
    );
    builder.addCase(
      getBasicDataForServicesOfResources.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error;
      }
    );
  },
});

export const selectState = (state: RootState) => state.dailytable.services;

export const { setError } = dtServiceSlice.actions;

export default dtServiceSlice.reducer;
